import React from 'react';

type Props = {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  isRequired?: boolean;
  error?: boolean | string;
};

const InputField: React.FC<Props> = ({
  value,
  onChange,
  label,
  placeholder,
  isRequired = false,
  error,
}) => {
  return (
    <div className="flex flex-col justify-center gap-3 relative">
      <div className="flex justify-between items-center gap-2">
        <label className="text-[0.875rem]">{label}</label>
        {isRequired && <div>*</div>}
      </div>
      <input
        type="text"
        className="w-full p-4 bg-[#32395E] outline-none rounded-[1rem] transition-all duration-300 focus:bg-[#465184]"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && (
        <div className="absolute text-red-500 bottom-[-1.7rem]">{error}</div>
      )}
    </div>
  );
};

export default InputField;
